export default __webpack_public_path__ + "static/media/logo-empresa.497f44b4.png";